// extracted by mini-css-extract-plugin
export default {"container":"aQOtN_container","text-normal":"Xkg8j_text-normal","option-image":"CPAWh_option-image","text-selected":"KzB3T_text-selected","text-baseline":"lwxZx_text-baseline"};